export default "__VITE_ASSET__BaxKpXq___"